module.exports = {
	"actions": "Actions",
	"add": "Ajouter",
	"amount": "Montant",
	"amount_plural": "Montants",
	"authenticationIssue": "Problème d'authentification. Veuillez essayer de nouveau.",
	"authorizationRequiredFor": "Autorisation requise",
	"backToTop": "Retour au haut de la page",
	"bidder": "Utilisateur",
	"bidNow": "Enchérir maintenant!",
	"brand": "Auctionex",
	"buyer": "Acheteur",
	"by": "par",
	"cancel": "Annuler",
	"canceled": "Annulé",
	"cannotUndo": "Cette action est irréversible.",
	"caution": "Attention",
	"claimed": "Réclamé",
	"cancelChanges": "Annuler les changements",
	"close": "Fermer",
	"contact": {
		"addressLn1": "Adresse ligne 1",
		"addressLn1Placeholder": "No. civique ou boîte postale.",
		"addressLn2": "Adresse ligne 2",
		"addressLn2Placeholder": "Appartement, suite, bâtiment, étage, etc.",
		"city": "Ville",
		"cityPlaceholder": "Nom de la ville",
		"country": "Pays",
		"countryPlaceholder": "Nom du pays",
		"postalCode": "Code postal",
		"postalCodePlaceholder": "Code postal ou zip",
		"region": "Province/État/Région",
		"regionPlaceholder": "Province/État/Région",
		"telephone": "Téléphone",
		"telephonePlaceholder": "+1-514-700-2050",
		"website": "Site web",
		"websitePlaceholder": "http://www.exemple.com"
	},
	"companyName": "Novivia",
	"companyNameInc": "$t(general::companyName) Inc.",
	"continue": "Continuer",
	"creationDate": "Date de création",
	"database": "la base de données",
	"date": "Date",
	"day": "Jour",
	"deny": "Refuser",
	"description": "Description",
	"discardChanges": "Annuler les changements",
	"downgrade": "Rétrograder",
	"downloadFileType": "Télécharger __fileType__",
	"edit": "Modifier",
	"end": "Fin",
	"error": "Erreur",
	"exportToPdf": "Exporter en PDF",
	"fullName": "Nom complet",
	"grant": "Accepter",
	"here": "ici",
	"ID": "ID",
	"increment_plural": "Incréments",
	"increment": "Incrément",
	"infinity": "Infini",
	"infoUpdated": "Information mise à jour.",
	"informationDisplayedOnProfile": "Cette information sera affichée sur votre profil.",
	"insert": "Insérer",
	"items": "items",
	"justNow": "Maintenant.",
	"learnMore": "En savoir plus",
	"left": "restant",
	"loading": "Chargement",
	"loggedIn": "Vous devez être connecté.",
	"manageit": "Vous pouvez maintenant le gérer.",
	"modificationsSaved": "Modifications enregistrées.",
	"month": "Mois",
	"monthly": "Mensuel",
	"moreInformation": "Plus d'information",
	"name": "Nom",
	"noDescription": "Aucune description disponible.",
	"none": "Aucun",
	"none_female": "Aucune",
	"numberShort": "no. ",
	"or": "ou",
	"outsideCanada": "À l'extérieur du Canada",
	"payment": "Paiement",
	"percentage": "Pourcentage",
	"periodFrom": "Période débutant le",
	"periodTo": "et se terminant le",
	"pleaseLogIn": "Veuillez vous connecter ou créer un compte",
	"pleaseLogInToContinue": "$t(general::pleaseLogIn) pour continuer",
	"pleaseTryAgain": "Essayez de nouveau.",
	"poweredBy": "Propulsé par",
	"prebidding": "Pré-offre",
	"preview": "Cette page est un aperçu visible uniquement par vous.",
	"price": "Prix",
	"primary": "principal",
	"quantity": "Quantité",
	"rank": "Rang",
	"rate": "Taux",
	"return": "Retour",
	"remove": "Enlever",
	"retry": "Réessayer",
	"saveChanges": "Sauvegarder les changements",
	"search": "Recherche",
	"seeDetails": "Voir détails",
	"selfXss": "Ne RIEN coller ici. Il y a de fortes chances que quelqu'un veuille voler vos informations ou agir sous votre identité.",
	"seller": "Vendeur",
	"setDefault": "Par défaut",
	"shipping": "Livraison",
	"start": "démarrer",
	"status": "Statut",
	"submit": "Envoyer",
	"subTotal": "Sous-total",
	"success": "Succès!",
	"switchTo": "Changer à __switchTo__",
	"taxes": "Taxes",
	"terms": "Conditions d'utilisation",
	"to": "à",
	"total": "Total",
	"type": "Type",
	"unknown": "Inconnu",
	"updateBtn": "Sauvegarder les modifications",
	"upgrade": "Améliorer",
	"userSubmitted": "Envoyé par l'utilisateur",
	"viewListing": "Voir les fiches",
	"warning": "Attention",
	"website": "le site web",
	"year": "Année",
	"yearly": "Annuel",
	"you": "Vous"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/general.json5
// module id = 1984
// module chunks = 6